import styled from 'styled-components';

// eslint-disable-next-line import/prefer-default-export
export const Container = styled.div.attrs(() => ({
  className: 'SettingsMemberProfileContainer',
}))`
  max-width: 960px;
  width: 95%;
  margin: 0 auto;
  padding: 36px 20px 70px 20px;
  overflow-x: hidden;

  .breadcrumbs-container {
    padding: 20px 0;
    margin: 0;
  }

  #MemberProfileTabs {
    max-width: 320px;
    padding: 36px 20px 70px 20px;

    > div {
      font-size: 16px;
      font-weight: normal;
    }

    .legoTabsWrapper {
      .legoTabsItem {
        font-weight: bold;
      }
    }
  }
`;

export const ContentContainer = styled.div.attrs(() => ({
  className: 'MemberProfileContentContainer',
}))`
  margin-bottom: 100px;
  background-color: #ffffff;
  box-shadow: rgb(0 0 0 / 8%) 0px 2px 4px 0px;

  .legoSelecterOptionsContainer .legoSelecterOptionsList {
    overflow: auto;
    margin-bottom: 0;
    max-height: 158px;
  }
`;
